import { render, staticRenderFns } from "./Bookmarks.form.vue?vue&type=template&id=579831c8&scoped=true&lang=pug&"
import script from "./Bookmarks.form.vue?vue&type=script&lang=ts&"
export * from "./Bookmarks.form.vue?vue&type=script&lang=ts&"
import style0 from "./Bookmarks.form.vue?vue&type=style&index=0&id=579831c8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579831c8",
  null
  
)

export default component.exports